import { SvgCommonProperties } from '../../common/svg.interfaces';

export default function ArrowRightSvg(props: SvgCommonProperties){
  return <svg
    height={props.height}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="w-6 h-6"
  >
    <path d="M5 12h14M12 5l7 7-7 7" />
  </svg>
}